export default __webpack_public_path__ + "static/media/34.70cdf914.mp3";